import { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { BenefitBalancesFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { BenefitBalancesList } from '../BenefitBalancesList'

type MyBenefitsHomePageProps = {
  benefitBalancesList: BenefitBalancesFragment
}

const MyBenefitsHome = ({ benefitBalancesList }: MyBenefitsHomePageProps) => {
  const { employee } = useCurrentSession()
  const country = employee?.legalEntity?.country || 'es'

  const description =
    country === 'pt'
      ? i18n.t('benefits.my_benefits.homepage.description_pt')
      : i18n.t('benefits.my_benefits.homepage.description')

  useEffect(() => {
    track(trackingEvents.benefits.openMyBenefitsHomePage)
  }, [])

  return (
    <ResponsivePage.Body showHeader={false} variant="full">
      <SectionHeader
        title={i18n.t('benefits.my_benefits.homepage.title')}
        description={description}
        supportButton={{
          label: i18n.t('common.learn_more'),
          href: 'https://help.factorialhr.com/beneficios',
        }}
      />

      <Box paddingTop="s24" />
      <BenefitBalancesList benefitBalancesList={benefitBalancesList} />
    </ResponsivePage.Body>
  )
}

export { MyBenefitsHome }
